import { isFileAccepted } from './accept';

/** Validate a file against type and size constraints. Returns an AC-exact error string or null. */
export function validateFile(
  file: File,
  opts: { accept?: string; maxSizeMb?: number },
): string | null {
  if (!isFileAccepted(file, opts.accept)) return 'Please upload a valid file';
  if (opts.maxSizeMb && file.size > opts.maxSizeMb * 1024 * 1024)
    return `File size should be less than ${opts.maxSizeMb}MB`;
  return null;
}
